import {createAsyncThunk} from "@reduxjs/toolkit";

import {
    getCatalogs as getCatalogsApi, getCatalogDescendent as getDescendantsApi,
    createCatalogs as createCatalogsApi, updateCatalogs as updateCatalogsApi, deleteCatalogs,

} from "./api";
import 'react-toastify/dist/ReactToastify.css';
import {toast} from "react-toastify";

export const getCatalogs = createAsyncThunk("catalogs/getCatalogs", async () => {
    try {
        return await getCatalogsApi();
    } catch (error) {
        return error;
    }
})

export const getDescendants = createAsyncThunk("descendants/getDescendants", async (id: any) => {
    try {
        return await getDescendantsApi(id);
    } catch (error) {
        return error;
    }
})

export const addCatalog = createAsyncThunk("catalog/addCatalog", async (catalog: any) => {
    try {

        const response = createCatalogsApi(catalog);
        const data = await response;
        toast.success("Catalogo creado", {autoClose: 3000});
        return data;
    } catch (error) {
        toast.error("Ocurrio un error en crear el catalogo", {autoClose: 3000});
        return error;
    }
});


export const updateCatalog = createAsyncThunk("catalog/updateCatalog", async ({catalog, idCatalog}: any) => {
    try {
        const response = updateCatalogsApi(catalog, idCatalog);
        const data = await response;
        toast.success("El catalogo se actualizo correctamente", {autoClose: 3000});
        return data;

    } catch (error) {
        toast.error("Ocurrio un error al actualizar el catalogo", {autoClose: 3000});
        return error;
    }
});

export const deletedCatalog = createAsyncThunk("catalog/deletedCatalog", async (id: string) => {
    try {
        const response = deleteCatalogs(id);
        const data = await response;
        toast.success("El catálogo se borró correctamente", {autoClose: 3000});
        return data;

    } catch (error) {
        toast.error("Ocurrio un error al borrar el catálogo", {autoClose: 3000});
        return error;
    }
});


